import { HeadCell } from 'shell/components/shared/table/types';
import { FamilyVM } from './family-vm';

export const headCellsPracticesAssign: HeadCell<FamilyVM, keyof FamilyVM>[] = [
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'fiscalCode',
    label: 'CF',
  },
  {
    id: 'birthDate',
    label: 'Data di nascita',
  },
  {
    id: 'birthplace',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'relationshipElement',
    label: 'Parentela',
  },
  {
    id: 'drivingLicenseElement',
    label: 'Patente',
  },
  {
    id: 'autoElement',
    label: 'Auto',
  },
  {
    id: 'aireElement',
    label: 'AIRE',
  },
  {
    id: 'cfControlElement',
    label: 'Controllo dati AE',
  },
];

export default headCellsPracticesAssign;
